import { mapImportPurchaseToFormValues } from './importMapper';
import { mapTaxCreditPurchaseToFormValues } from './taxCreditMapper';
import { mapCreditNotePurchaseToFormValues } from './creditNoteMapper';
import { mapExcludedSubjectPurchaseToFormValues } from './excludedSubjectMapper';
import { mapDebitNotePurchaseToFormValues } from './debitNoteMapper';

import { PurchaseDetail, PurchaseFormValues } from '../../types/purchases/BasePurchase';
import { DOCUMENT_TYPES } from '../../constants/purchase';

export const mapPurchaseDetailToFormValues = (
  purchase: PurchaseDetail
): PurchaseFormValues => {
  const docTypeId = purchase.documentType.id;

  switch (docTypeId) {
    case DOCUMENT_TYPES.TAX_CREDIT:
      return mapTaxCreditPurchaseToFormValues(purchase);
    case DOCUMENT_TYPES.IMPORT:
      return mapImportPurchaseToFormValues(purchase);
    case DOCUMENT_TYPES.EXCLUDED_SUBJECT:
      return mapExcludedSubjectPurchaseToFormValues(purchase);
    case DOCUMENT_TYPES.CREDIT_NOTE:
      return mapCreditNotePurchaseToFormValues(purchase);
    case DOCUMENT_TYPES.DEBIT_NOTE:
      return mapDebitNotePurchaseToFormValues(purchase);
    default:
      console.warn(`🟡 Tipo de documento no reconocido: ${docTypeId}`);
      return {} as PurchaseFormValues;
  }
};
